import { NgFor, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-rows-dropdown',
  standalone: true,
  imports: [NgFor, NgIf, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem],
  templateUrl: './view-rows-dropdown.component.html',
  styleUrls: ['./view-rows-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewRowsDropdownComponent implements OnChanges {
  @Input() initialValue: number = 10;
  @Output() selectionChanged = new EventEmitter<number>();

  public options: number[] = [10, 25, 50, 75, 100];
  public top: number = 10;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initialValue && changes.initialValue.firstChange) {
      this.top = this.initialValue;
    }
  }

  public setSelection(option: number): void {
    this.top = option;
    this.selectionChanged.emit(option);
  }
}
